export const products = [
  {
    id: "SG-M-P",
    name: "Meridian Polarized",
    category: "Sunglasses",
    gender: "Men",
    tier: "Premium",
    price_inr: 3499,
    frame: "Metal aviator, gradient lens",
    lens_features: ["Polarized", "UV400"],
    face_shapes_suited: ["oval", "square", "heart"],
    colour: "Gunmetal",
    pitch: "Glare-killing polarized aviators for drives and bright days.",
  },
  {
    id: "SG-M-V",
    name: "Meridian Lite",
    category: "Sunglasses",
    gender: "Men",
    tier: "Value",
    price_inr: 1299,
    frame: "Acetate wayfarer",
    lens_features: ["UV400"],
    face_shapes_suited: ["round", "oval"],
    colour: "Matte Black",
    pitch: "Everyday UV-protected wayfarers that go with everything.",
  },
  {
    id: "SG-W-P",
    name: "Aria Gradient",
    category: "Sunglasses",
    gender: "Women",
    tier: "Premium",
    price_inr: 3299,
    frame: "Oversized acetate",
    lens_features: ["Polarized", "Gradient", "UV400"],
    face_shapes_suited: ["heart", "oval", "square"],
    colour: "Tortoise",
    pitch: "Oversized polarized gradients \u2014 sun protection with drama.",
  },
  {
    id: "SG-W-V",
    name: "Aria Everyday",
    category: "Sunglasses",
    gender: "Women",
    tier: "Value",
    price_inr: 1199,
    frame: "Lightweight cat-eye",
    lens_features: ["UV protection"],
    face_shapes_suited: ["round", "oblong"],
    colour: "Rose",
    pitch: "Featherlight cat-eye sunnies for daily wear.",
  },
  {
    id: "EG-M-P",
    name: "Axis Blu Titanium",
    category: "Eyeglasses",
    gender: "Men",
    tier: "Premium",
    price_inr: 4199,
    frame: "Titanium rectangular, featherweight",
    lens_features: ["Blue-light", "Anti-glare"],
    face_shapes_suited: ["round", "oval", "heart"],
    colour: "Brushed Silver",
    pitch: "Titanium blue-light glasses you forget you\u2019re wearing.",
  },
  {
    id: "EG-M-V",
    name: "Axis Blu Core",
    category: "Eyeglasses",
    gender: "Men",
    tier: "Value",
    price_inr: 1499,
    frame: "TR90 rectangular",
    lens_features: ["Blue-light"],
    face_shapes_suited: ["square", "oval"],
    colour: "Black",
    pitch: "Durable blue-light basics for all-day screens.",
  },
  {
    id: "EG-W-P",
    name: "Lumen Thin",
    category: "Eyeglasses",
    gender: "Women",
    tier: "Premium",
    price_inr: 3999,
    frame: "Ultra-thin designer acetate",
    lens_features: ["Blue-light", "Anti-glare"],
    face_shapes_suited: ["oval", "square", "oblong"],
    colour: "Burgundy",
    pitch: "Ultra-thin designer blue-light frames, barely there.",
  },
  {
    id: "EG-W-V",
    name: "Lumen Bright",
    category: "Eyeglasses",
    gender: "Women",
    tier: "Value",
    price_inr: 1299,
    frame: "Colourful acetate round",
    lens_features: ["Blue-light"],
    face_shapes_suited: ["heart", "round"],
    colour: "Teal",
    pitch: "Fun, colourful blue-light frames that pop.",
  },
];

// EXACT pre-computed WhatsApp deep links (Section 5) — do NOT construct or re-encode.
export const WHATSAPP_LINKS = {
  "SG-M-P":
    "https://wa.me/919011143792?text=Hi%21%20I%27m%20looking%20at%20the%20Meridian%20Polarized%20%28Men%2C%20Premium%29%20on%20VZOR.%20Help%20me%20decide%3F",
  "SG-M-V":
    "https://wa.me/919011143792?text=Hi%21%20I%27m%20looking%20at%20the%20Meridian%20Lite%20%28Men%2C%20Value%29%20on%20VZOR.%20Help%20me%20decide%3F",
  "SG-W-P":
    "https://wa.me/919011143792?text=Hi%21%20I%27m%20looking%20at%20the%20Aria%20Gradient%20%28Women%2C%20Premium%29%20on%20VZOR.%20Help%20me%20decide%3F",
  "SG-W-V":
    "https://wa.me/919011143792?text=Hi%21%20I%27m%20looking%20at%20the%20Aria%20Everyday%20%28Women%2C%20Value%29%20on%20VZOR.%20Help%20me%20decide%3F",
  "EG-M-P":
    "https://wa.me/919011143792?text=Hi%21%20I%27m%20looking%20at%20the%20Axis%20Blu%20Titanium%20%28Men%2C%20Premium%29%20on%20VZOR.%20Help%20me%20decide%3F",
  "EG-M-V":
    "https://wa.me/919011143792?text=Hi%21%20I%27m%20looking%20at%20the%20Axis%20Blu%20Core%20%28Men%2C%20Value%29%20on%20VZOR.%20Help%20me%20decide%3F",
  "EG-W-P":
    "https://wa.me/919011143792?text=Hi%21%20I%27m%20looking%20at%20the%20Lumen%20Thin%20%28Women%2C%20Premium%29%20on%20VZOR.%20Help%20me%20decide%3F",
  "EG-W-V":
    "https://wa.me/919011143792?text=Hi%21%20I%27m%20looking%20at%20the%20Lumen%20Bright%20%28Women%2C%20Value%29%20on%20VZOR.%20Help%20me%20decide%3F",
};

export const productById = (id) => products.find((p) => p.id === id);
export const productImage = (id) => `/products/${id}.png`;
